// Module
var code = "<div class=\"input-group\"> <div class=\"input-group-addon\">+1</div> <input class=\"form-control\" ng-model=\"vm.value\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\" type=\"tel\"> </div> ";
// Exports
module.exports = code;